import { createChatRoutes } from './chat/routes';
import { createContactsRoutes } from './contacts/routes';
import { createJobsRoutes } from './jobs/routes';
import { createMyListsRoutes } from './me/my-lists/routes';
import { createMyPerformanceRoutes } from './me/my-performance/routes';
import { createMyTasksRoutes } from './me/my-tasks/routes';
import { createMyTimeRoutes } from './me/my-time/routes';
import { createPerformanceRoutes } from './performance/routes';
import { createWorkspaceProfileRoutes } from './profile/routes';
import { createQuickTasksRoutes } from './quick-tasks/routes';
import { createSettingsRoutes } from './settings/routes';

export type ContactsRoutes = ReturnType<typeof createContactsRoutes>;
export type ChatRoutes = ReturnType<typeof createChatRoutes>;
export type JobsRoutes = ReturnType<typeof createJobsRoutes>;
export type QuickTasksRoutes = ReturnType<typeof createQuickTasksRoutes>;
export type MyListsRoutes = ReturnType<typeof createMyListsRoutes>;
export type MyPerformanceRoutes = ReturnType<typeof createMyPerformanceRoutes>;
export type MyTasksRoutes = ReturnType<typeof createMyTasksRoutes>;
export type MyTimeRoutes = ReturnType<typeof createMyTimeRoutes>;
export type PerformanceRoutes = ReturnType<typeof createPerformanceRoutes>;
export type WorkspaceProfileRoutes = ReturnType<
  typeof createWorkspaceProfileRoutes
>;
export type SettingsRoutes = ReturnType<typeof createSettingsRoutes>;

export type WorkspaceRoutes = {
  index: (slug: string) => string;
  contacts: (slug: string) => ContactsRoutes;
  chat: (slug: string) => ChatRoutes;
  jobs: (slug: string) => JobsRoutes;
  quickTasks: (slug: string) => QuickTasksRoutes;
  myLists: (slug: string) => MyListsRoutes;
  myPerformance: (slug: string) => MyPerformanceRoutes;
  myTasks: (slug: string) => MyTasksRoutes;
  myTime: (slug: string) => MyTimeRoutes;
  performance: (slug: string) => PerformanceRoutes;
  profile: (slug: string) => WorkspaceProfileRoutes;
  settings: (slug: string) => SettingsRoutes;
};

export const workspaceRoutes: WorkspaceRoutes = {
  index: (slug: string) => `/${slug}`,
  contacts: (slug: string) => createContactsRoutes(`/${slug}/contacts`),
  chat: (slug: string) => createChatRoutes(`/${slug}/chat`),
  jobs: (slug: string) => createJobsRoutes(`/${slug}/jobs`),
  quickTasks: (slug: string) => createQuickTasksRoutes(`/${slug}/quick-tasks`),
  myTasks: (slug: string) => createMyTasksRoutes(`/${slug}/me/my-tasks`),
  myLists: (slug: string) => createMyListsRoutes(`/${slug}/me/my-lists`),
  myTime: (slug: string) => createMyTimeRoutes(`/${slug}/me/my-time`),
  myPerformance: (slug: string) =>
    createMyPerformanceRoutes(`/${slug}/me/my-performance`),
  performance: (slug: string) =>
    createPerformanceRoutes(`/${slug}/performance`),
  profile: (slug: string) => createWorkspaceProfileRoutes(`/${slug}/profile`),
  settings: (slug: string) => createSettingsRoutes(`/${slug}/settings`),
};
